// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1bwaw","notes":"Notes_notes__EdWUB"};